import { defineComponent, ref } from 'vue';
import { Autoplay, Navigation } from 'swiper';
import { Swiper, SwiperSlide } from 'swiper/vue';
import 'swiper/less';
import 'swiper/less/autoplay';
import 'swiper/less/navigation';
import ExcellentWorkCard from './ExcellentWorkCard.vue';
import WorkDetail from '@/components/WorkDetail.vue';
export default defineComponent({
  name: 'ExcellentWorkList',
  props: {
    list: {
      type: Array,
      default: function () {
        return [];
      }
    }
  },
  components: {
    Swiper: Swiper,
    SwiperSlide: SwiperSlide,
    ExcellentWorkCard: ExcellentWorkCard,
    WorkDetail: WorkDetail
  },
  setup: function () {
    var btnPrevRef = ref();
    var btnNextRef = ref();
    var selectedCard = ref();
    var onCardSelect = function (work) {
      work.visible = true;
      selectedCard.value = work;
    };
    return {
      modules: [Autoplay, Navigation],
      btnPrevRef: btnPrevRef,
      btnNextRef: btnNextRef,
      onCardSelect: onCardSelect,
      selectedCard: selectedCard
    };
  }
});